import { FormControl, Box, Chip, Modal, Typography, TextField, Checkbox, MenuItem } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import GenericButton, { GenericButtonTypeEnum } from '../../../components/GenericButton';
import { getUnengagedTeachers } from '../../../api/group.api';
import { UnengagedTeacherDto } from '../../../common/interfaces/group.interface';
import Autocomplete from '@mui/material/Autocomplete';
import { CommonModalActionsBox, CommonModalContentBox, CommonModalWrapperBox } from '../../../common/styles/Common.styles';
import GenericPeopleDropdown from '../../../components/GenericPeopleDropdown';
import { useTranslation } from 'react-i18next';

const CreateTeacherGroupEngagementModal: FC<{
  onClose: () => void;
  onConfirm: (selectedTeachers: UnengagedTeacherDto[]) => void;
  kindergartenId: string;
  groupId: string;
}> = ({ onClose, onConfirm, kindergartenId, groupId }) => {
  const { t } = useTranslation();
  const [selectedTeachers, setSelectedTeachers] = useState<UnengagedTeacherDto[]>([]);
  const [teachers, setTeachers] = useState<UnengagedTeacherDto[]>([]);

  useEffect(() => {
    getTeachers();
  }, []);

  const getTeachers = async () => {
    try {
      const res = await getUnengagedTeachers(groupId, kindergartenId);
      setTeachers(res.results ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = () => {
    onConfirm(selectedTeachers);
  };

  return (
    <Modal open={true} onClose={onClose}>
      <CommonModalWrapperBox
        sx={{
          width: 520
        }}
      >
        <Typography variant="h6">{t('groups.addTeacher')}</Typography>
        <CommonModalContentBox>
          <FormControl sx={{ m: 1, width: '100%' }}>
            <GenericPeopleDropdown
              label={`${t('groups.teacher')}*`}
              options={teachers}
              selectedOptions={selectedTeachers}
              onChange={selected => setSelectedTeachers(selected as UnengagedTeacherDto[])}
            />
          </FormControl>

          <CommonModalActionsBox>
            <GenericButton buttonType={GenericButtonTypeEnum.Neutral} variant="text" onClick={onClose} label={t('common.cancel')} />
            <GenericButton
              buttonType={GenericButtonTypeEnum.Primary}
              isActive={selectedTeachers.length > 0}
              onClick={handleSubmit}
              disabled={selectedTeachers.length === 0}
              label={t('common.save')}
            />
          </CommonModalActionsBox>
        </CommonModalContentBox>
      </CommonModalWrapperBox>
    </Modal>
  );
};

export default CreateTeacherGroupEngagementModal;
